import { filterCategoryDetailByType } from 'helpers/Search';
import { CategoryDetail, SearchCategoryType } from 'types/Search';

//for values which we get in backend in string value format

//for technical properties are in value:{} formaqt with type
export const getPropertyValuesByType = (
  value: CategoryDetail[],
  type: SearchCategoryType
) =>
  filterCategoryDetailByType(type, value)
    .map(el => el.value)
    .join(', ');

export const getValueStrings = (category: { value: string }[]) =>
  category.map(el => el.value).join(', ');

/**
 * Origins are saved uppercase in the backend, therefore we need to capitalize them now...
 *
 * @deprecated We should never use this function again. Fix the problem in the backend instead.
 */
export const getValueStringsCaptalized = (category: { value: string }[]) =>
  category
    .map(v => v.value)
    .map(v => v.charAt(0) + v.slice(1).toLowerCase())
    .join(', ');
